import type React from 'react';
import styles from './VulnerabilityManagement.module.css';

interface VulnerabilityFiltersProps {
  searchTerm: string;
  severityFilter: string;
  statusFilter: string;
  falsePositivesOnly: boolean;
  hasActiveFilters: boolean;
  onSearchChange: (value: string) => void;
  onSeverityChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onFalsePositiveChange: (value: boolean) => void;
  onResetFilters: () => void;
}

export const VulnerabilityFilters: React.FC<VulnerabilityFiltersProps> = ({
  searchTerm,
  severityFilter,
  statusFilter,
  falsePositivesOnly,
  hasActiveFilters,
  onSearchChange,
  onSeverityChange,
  onStatusChange,
  onFalsePositiveChange,
  onResetFilters,
}) => {
  return (
    <div className={styles.filtersBar}>
      <input
        className={styles.searchBar}
        type="text"
        placeholder="Search vulnerabilities..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <select className={styles.filterSelect} value={severityFilter} onChange={(e) => onSeverityChange(e.target.value)}>
        <option value="">All Severities</option>
        <option value="critical">Critical</option>
        <option value="high">High</option>
        <option value="medium">Medium</option>
        <option value="low">Low</option>
      </select>
      <select className={styles.filterSelect} value={statusFilter} onChange={(e) => onStatusChange(e.target.value)}>
        <option value="">All Statuses</option>
        <option value="open">Open</option>
        <option value="confirmed">Confirmed</option>
        <option value="fixed">Fixed</option>
        <option value="false_positive">False Positive</option>
        <option value="retesting">Retesting</option>
      </select>
      <select
        className={styles.filterSelect}
        value={falsePositivesOnly ? 'true' : ''}
        onChange={(e) => onFalsePositiveChange(e.target.value === 'true')}
      >
        <option value="">All Items</option>
        <option value="true">False Positives Only</option>
      </select>
      {hasActiveFilters && (
        <button className={styles.resetButton} onClick={onResetFilters}>
          Clear Filters
        </button>
      )}
    </div>
  );
};
